import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MuiAvatar from '@zenbusiness/zui/Avatar';
import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Content = superstyled({
  name: 'Content',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
    },
  }),
});

export const Avatar = superstyled({
  name: 'Avatar',
  slot: 'Root',
  tag: MuiAvatar,
  propsAdded: {
    variant: 'square',
  },
  styles: ({ theme }) => ({
    border: 'none',
    borderRadius: theme.shape.rounded.md,
    backgroundColor: theme.palette.primary.light,
    height: '2.5rem',
    width: '2.5rem',
  }),
});

export const ProfileWrapper = superstyled({
  name: 'ProfileWrapper',
  slot: 'Root',
  styles: ({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
    },
  }),
});

export const TextContainer = superstyled({
  name: 'TextContainer',
  slot: 'Root',
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
});

export const MutedText = superstyled({
  name: 'MutedText',
  slot: 'Root',
  tag: Text,
  styles: () => ({
    color: 'rgba(255, 255, 255, 0.6)',
  }),
});

export const CopiedIcon = superstyled({
  name: 'CopiedIcon',
  slot: 'Root',
  tag: CheckIcon,
  styles: () => ({
    fontSize: '0.875rem',
  }),
});

export const CopyIcon = superstyled({
  name: 'CopyIcon',
  slot: 'Root',
  tag: ContentCopyIcon,
  styles: () => ({
    fontSize: '0.875rem',
  }),
});

export const LoadingOuter = superstyled({
  name: 'LoadingOuter',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  }),
});

export const LoadingEntity = superstyled({
  name: 'LoadingEntity',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flexDirection: 'row',
  }),
});

export const LoadingAvatarWrapper = superstyled({
  name: 'LoadingAvatarWrapper',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    minWidth: '60px',
  }),
});

export const LoadingStatus = superstyled({
  name: 'LoadingStatus',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  }),
});
